import React, { useState, useMemo, useEffect } from 'react'
import { Modal } from 'antd'
import { LeftCircleFilled, RightCircleFilled } from '@ant-design/icons'
import styles from './index.module.scss'

interface PreviewImgProps {
  open: boolean;
  onCancel: () => void;
  src: string;
  imgList: string[];
}

const PreviewImg: React.FC<PreviewImgProps> = (props) => {
  const { open, onCancel, src, imgList } = props
  const [current, setCurrent] = useState<number>(-1)
  
  useEffect(() => {
    let index = imgList.indexOf(src)
    if(index > -1) {
      setCurrent(index)
    }else {
      setCurrent(-1)
    }
  }, [src, imgList])

  const viewImgSrc = useMemo(() => {
    let _src = ''
    if(current > -1 && imgList[current]) {
      _src = imgList[current]
    }
    return src
  }, [current, imgList])

  const viewPreClick = () => {
    if(current > 0) {
      setCurrent(current - 1)
    }else {
      return false
    }
  }
  const viewNextClick = () => {
    if(current === imgList.length - 1) {
      return false
    }else {
      setCurrent(current + 1)
    }
  }
  return (
    <Modal
      open={open}
      width={900}
      footer={null}
      onCancel={() => onCancel()}
    >
      <div className={styles['view-img']}>
        <span onClick={viewPreClick}>
          <LeftCircleFilled style={{fontSize: 56, color: 'rgba(0, 0, 0, 0.2)'}}/>
        </span>
        <div>
          <img src={viewImgSrc} alt="" />
        </div>
        <span onClick={viewNextClick}>
          <RightCircleFilled style={{fontSize: 56, color: 'rgba(0, 0, 0, 0.2)'}}/>
        </span>
      </div>
    </Modal>
  )
}
export default PreviewImg
